import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label is-inline-flex is-align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Rep", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "---", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_loading = _resolveComponent("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_tooltip, {
        class: "sales-rep-tooltip-icon is-inline ml-2",
        content: _ctx.tooltipContent,
        position: 'bottom',
        filter: 'span'
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    (_ctx.rep?.name)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.rep.name), 1)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ])),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 2,
          class: "for-field"
        }))
      : _createCommentVNode("", true)
  ]))
}